import { AppVersionMiddleware } from "@/utils/api/middleware";
import { getFromQueryString } from "@/utils/url";
import { Configuration, DefaultApi } from "@/api";
import { Store } from "@/store";

type InitApiOptions = {
  useSendBeacon?: boolean;
  basePath?: string;
};

export function initApi(props: InitApiOptions = {}) {
  const fetchApi = getFetchApi(props.useSendBeacon);
  const appVersionMiddleware = new AppVersionMiddleware(Store.app.appVersion.value);

  const configuration = new Configuration({
    basePath: props.basePath ?? window.location.origin,
    middleware: [appVersionMiddleware],
    headers: {
      accept: "application/json",
      ...getImpersonationHeaders(),
    },
    fetchApi,
  });

  return new DefaultApi(configuration);
}

function getFetchApi(useSendBeacon = false) {
  return (input: RequestInfo, init?: RequestInit) => {
    if (useSendBeacon && navigator.sendBeacon && init?.method === "POST" && init.body) {
      navigator.sendBeacon(input as string, init.body);
      return Promise.resolve(new Response());
    }
    return fetch(input, init);
  };
}

export function getImpersonationHeaders(): Record<string, string> {
  const userId = getFromQueryString("userId");

  if (userId) {
    return {
      "X-Impersonate-User-ID": userId,
    };
  }

  const userEmail = getFromQueryString("userEmail");
  if (userEmail) {
    return {
      "X-Impersonate-User-Email": userEmail,
    };
  }

  return {};
}
